import { NgModule } from '@angular/core';
import { CommercialIntentTableComponent } from './commercial-intent-table.component';
import { DriverCommercialIntentHistoryModalComponent } from './driver-commercial-intent-history-modal.component';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { DriverCommercialIntentService } from '@max/driver/services/driver-commercial-intent.service';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';

@NgModule({
    declarations : [
        CommercialIntentTableComponent,
        DriverCommercialIntentHistoryModalComponent
    ],
    imports : [
        CommonModule,
        TableModule,
        CalendarModule,
        SharedPipesModule
    ],
    providers: [
        DriverCommercialIntentService
    ],
    exports : [
        CommercialIntentTableComponent,
        DriverCommercialIntentHistoryModalComponent
    ],
})
export class CommercialIntentTableModule {}
